<style lang="scss" scoped>
ul,
li {
  padding: 0px;
  margin: 0px;
  list-style: none;
  text-decoration: none;
}
.user-dropdown {
  .el-button--text {
    font-size: 14px;
    color: #fff;
  }
  .el-button--text:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
  //padding-right: 20px;
  box-sizing: border-box;
  text-align: center;
  height: 100%;
}
.xiaoxi_icon {
  color: #fff;
  font-size: 16px;
}
.bodyDiv {
  height: 38px;
}
.bodyRow {
  height: 38px;
  text-align: center;
  /*flex 布局*/
  display: flex;
  /*实现垂直居中*/
  align-items: center;
  /*实现水平居中*/
  justify-content: center;

  text-align: center;
}
.bodyRow2 {
  text-align: center;
  /*flex 布局*/
  // display: flex;
  /*实现垂直居中*/
  align-items: center;
  /*实现水平居中*/
  justify-content: center;
}
.messagebutton {
  color: #fff;

  font-size: 20px;
}
.weiduDiv {
  background-color: #fff;
  height: 200px;
  width: 200px;
  opacity: 0.5;
  top: 200px;
}
.weiduSpan {
  width: 32px;
  height: 16px;
  -webkit-transform: translate(-50%, -100%);
  transform: translate(50%, 100%);
  position: relative;
  /* overflow: hidden; */
  pointer-events: none;
  top: 1px;
  left: -10px;
}
.weiduSpan::after {
  content: "";
  position: absolute;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 24px;
  height: 24px;
  margin: -12px;
  border: 1px solid #ebebeb;
  background: #fff;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  pointer-events: auto;
}

.weiduxiaoxirow {
  position: relative;
  .weiduxiaoxiparent {
    // background-color: aqua;
    display: none;
    i {
      top: 20px;
      left: 52px;
      position: absolute;
      color: #fff;
      text-shadow: 1px -1px #ccc, -1px -1px #ccc;
      //opacity:0.5;
    }
  }
  .weiduxiaoxi {
    border: solid 1px #fff;
    position: absolute;
    width: 220px;
    height: 220px;
    overflow-y: auto;
    top: 29px;
    left: -51px;
    background-color: #fff;
    border-radius: 10px;
    font-size: 14px;
    //opacity:0.5;
    ul {
      li {
        color: #606266;
        padding: 10px 10px;
        border-bottom: 1px solid #ebeef5;
        cursor: pointer;
        // text-shadow: 1px 1px #ccc;
      }
      li:hover {
        background-color: #ecf5ff;
        color: #66b1ff;
      }
    }
  }
}
.weiduxiaoxirow:hover > .weiduxiaoxiparent {
  display: block;
}
</style>
<template>
  <div class="bodyDiv">
    <div class="user-dropdown">
      <el-row class="bodyRow">
        <el-col :span="8">
          <!-- <span style="color: #fff">报警弹窗：</span>
          <el-switch
            v-model="baojingtanchuang"
            active-color="#1891ff"
            inactive-color="#eeeeee"
          >
          </el-switch> -->
        </el-col>
        <el-col :span="6" style="text-align: center" class="weiduxiaoxirow">
          <el-badge :value="ReviewerApplySize" class="item">
            <!-- <el-button size="small" class="messagebutton">我的消息</el-button> -->
            <i class="el-icon-bell messagebutton"></i>
          </el-badge>
          <div class="weiduxiaoxiparent">
            <i class="icon-lingxing iconfont"></i>
            <div class="weiduxiaoxi">
              <ul>
                <a @click="aclick()">
                  <li
                    v-for="(item, index) in liList"
                    :key="index"
                    style="text-align: left"
                  >
                    {{ item.value }}
                  </li>
                </a>
              </ul>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <el-dropdown @command="userCommand" style="margin-left: 30px">
            <el-button type="text">
              <i class="el-icon-user-solid"></i>
              <span style="font-size: 16px">{{ username }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown" trigger="click">
              <el-dropdown-item command="changepw"
                ><li class="el-icon-key" style="margin-right: 5px"></li>
                修改密码</el-dropdown-item
              >
              <!-- <el-dropdown-item command="userinfo"
                ><li class="el-icon-user" style="margin-right: 5px"></li>
                个人信息</el-dropdown-item
              > -->
              <el-dropdown-item command="logout" divided
                ><li
                  class="el-icon-switch-button"
                  style="margin-right: 5px"
                ></li>
                退出登录</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>

      <!-- <el-badge :value="12" style="margin:0 40px;">
        <span class="xiaoxi_icon el-icon-chat-dot-round"></span>
      </el-badge> -->
      <!-- <span class="xiaoxi_icon el-icon-s-tools"></span> -->
    </div>
    <el-dialog
      title="修改密码"
      width="50%"
      :visible.sync="updatePassworVisible"
      :append-to-body="true"
      :before-close="handleClose"
      :close-on-click-modal="closeOnClickModal"
    >
      <el-form :model="passForm" :rules="passFormRules" ref="passForm">
        <!-- <el-form-item
          label="原密码"
          :label-width="passFormLableWith"
          prop="oldPassword"
        >
          <el-input
            type="password"
            v-model="passForm.oldPassword"
            auto-complete="off"
            clearable
          ></el-input>
        </el-form-item> -->
        <el-form-item
            label="旧密码"
            :label-width="passFormLableWith"
            prop="oldPassword"
        >
          <el-input
              type="password"
              v-model="passForm.oldPassword"
              auto-complete="off"
              clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="新密码"
          :label-width="passFormLableWith"
          prop="newPassword"
        >
          <el-input
            type="password"
            v-model="passForm.newPassword"
            auto-complete="off"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="确认新密码"
          :label-width="passFormLableWith"
          prop="confirmPassword"
        >
          <el-input
            type="password"
            v-model="passForm.confirmPassword"
            auto-complete="off"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="resetPass()">重置密码</el-button>
        <el-button @click="cancelPass('passForm')">取 消</el-button>
        <el-button type="primary" @click="submitPassForm('passForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="个人信息"
      :visible.sync="userInfoVisible"
      :append-to-body="true"
    >
      <el-row>
        <el-col :span="12" class="info-item">
          <span>工号</span>
          <span>{{ get("loginNo") }}</span>
        </el-col>
        <el-col :span="12" class="info-item">
          <span>姓名</span>
          <span>{{ get("loginName") }}</span>
        </el-col>
        <el-col :span="12" class="info-item">
          <span>归属</span>
          <span>{{ get("groupName") }}</span>
        </el-col>
        <el-col :span="12" class="info-item">
          <span>联系方式</span>
          <span>{{ get("tel") }}</span>
        </el-col>
        <el-col :span="12" class="info-item">
          <span>邮箱</span>
          <span>{{ get("email") }}</span>
        </el-col>
        <el-col :span="12" class="info-item">
          <span>创建人</span>
          <span>{{ get("createLogin") }}</span>
        </el-col>
        <el-col :span="12" class="info-item">
          <span>创建时间</span>
          <span>{{ get("createTime") }}</span>
        </el-col>
        <el-col :span="12" class="info-item">
          <span>员工编码</span>
          <span>{{ get("userCode") }}</span>
        </el-col>
        <el-col :span="24" class="info-item">
          <span>角色</span>
          <el-tag
            style="margin-right: 6px"
            v-for="item in roles"
            :key="item.roleId"
            >{{ item.roleName }}</el-tag
          >
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import { logout } from "../../../views/login/api";
import { updatePass } from  "../api";
import {findPeopleInput} from "../../../views/serviceapp/businessManage/personManage/myReviewerApply/api";
import bus from "@/utils/bus"

export default {
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.passForm.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      let reg =
        /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\\\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\\\\W_!@#$%^&*`~()-+=]+$)(?![0-9\\\\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\\\\W_!@#$%^&*`~()-+=]{8,30}$/;
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (!reg.test(value)) {
        callback(
          new Error(
            "新密码必须包含数字、大写字母、小写字母、特殊字字符4种中至少3种，且长度为8~30位"
          )
        );
      } else {
        callback();
      }
    };
    return {
      userInfoVisible: false,
      updatePassworVisible: false,
      closeOnClickModal: false,
      passFormLableWith: "100px",
      passForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      liList: [
      ],
      ReviewerApplySize: 0,
      passFormRules: {
        // oldPassword: [
        //   { trigger: "blur", required: true, message: "请输入原密码" },
        // ],
        oldPassword: [
          { trigger: "blur", required: true, message: "请输入原密码" },
          { validator: validatePass, trigger: "blur" },
        ],
        newPassword: [
          { trigger: "blur", required: true, message: "请输入新密码" },
          { validator: validatePass, trigger: "blur" },
        ],
        confirmPassword: [
          { trigger: "blur", required: true, message: "请再次输入新密码" },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
      baojingtanchuang: true,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.base;
    },
    roles() {
      return this.$store.state.user.roles;
    },
    username() {
      // let user = this.$store.state.user.base;
      // return user.loginName;
      // return this.$store.state.user.base;
      return this.$store.state.user.userInfo.nickName;
    },
  },
  mounted(){
    this.findReviewerApply();
  },
  methods: {
    findReviewerApply() {
      let data = {
        current: 1,
        size: 20,
        applyType: '0',
        applyState: '0',
      };
      findPeopleInput(data)
          .then((res) => {
            res.data.data.records.forEach(item => {
              this.liList.push({value: "来自于" + item.enterSchoolUsername + "的入校请求"});
            });
            this.ReviewerApplySize = res.data.data.total;
          });
    },
    handleClose(done) {
      this.$refs.passForm.resetFields();
      done();
    },
    cancelPass(formName) {
      this.$refs[formName].resetFields();
      this.updatePassworVisible = false;
    },
    aclick() {
      // alert("1");
      this.$router.push('/businessManage/myReviewerApply')
    },
    resetPass() {
      let data = new FormData();
      data.append("pasd", "123456");
      this.$confirm("确定要重置密码为123456么?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        updatePass(data)
          .then((result) => {
            if ("20000" == result.data.code) {
              this.$alert("密码修改成功，请重新登录", "提示", {
                type: "success",
              }).then((_) => {
                this.$router.replace("/");
              });
            } else {
              this.$alert("修改失败", "提示", { type: "error" });
            }
          })
          .catch((error) => {
            this.$alert("修改失败", "提示", { type: "error" });
          });
      });
    },
    submitPassForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // let data = {
          //   // username: this.user.loginNo,
          //   // oldPwd: this.passForm.oldPassword,
          //   newPwd: this.passForm.newPassword,
          // };
          let data = new FormData();
          // let tempData = new FormData();
          data.append("pasd", this.passForm.newPassword);
          data.append("oldPasd", this.passForm.oldPassword);
          this.$confirm("确定要修改密码?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            updatePass(data)
              .then((result) => {
                if ("20000" == result.data.code) {
                  this.$alert("密码修改成功，请重新登录", "提示", {
                    type: "success",
                  }).then((_) => {
                    this.$router.replace("/");
                  });
                } else {
                  this.$alert(result.data.message, "提示", { type: "error" });
                }
              })
              .catch((error) => {
                this.$alert("修改失败", "提示", { type: "error" });
              });
          });
        }
      });
    },
    userCommand(val) {
      if (val === "changepw") {
        //修改密码
        this.updatePassworVisible = true;
      } else if (val === "logout") {
        //退出登录
        var tempToken = sessionStorage.getItem("access_token");
        let reqData = {
          access_token: tempToken,
        };
        if (!tempToken) {
          this.$alert("登录已过期，请重新登录", {
            confirmButtonText: "确定",
            callback: (action) => {
              bus.$emit("onLogout")
              this.$router.replace("/");
            },
          });
        } else {
          this.$confirm("确定退出系统?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            logout(reqData).then((res) => {
              this.$router.push("/");
              bus.$emit("onLogout")
              setTimeout(() => {
                this.$store.dispatch("setUserInfo", "");
                // this.$store.dispatch("delAllTags");
                sessionStorage.clear();
              }, 200);
            });
          });
        }
      } else if (val === "userinfo") {
        this.userInfoVisible = true;
      }
    },
    get(key) {
      if (this.user && this.user[key]) {
        return this.user[key];
      } else {
        return "";
      }
    },
  },
};
</script>



